<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">Payment</h4>
                </div>
                <div class="modal-body">
                    <div *ngIf="!spinnerShow">
                        <!-- ___ Payment Method ___ -->
                        <div class="row m-b-sm">
                            <div class="col-md-5">
                                <label>Payment Method</label>
                            </div>
                            <div class="col-md-7">
                                <select class="form-control" name="paymentMethod" [(ngModel)]="data.paymentMethod">
                                    <option *ngFor="let method of availablePaymentMethods" [value]="method.value">
                                        {{method.displayName}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div *ngIf="data.paymentMethod == 'credit_card'">
                            <!-- ___ Card Holder Name ___ -->
                            <div class="row m-b-sm">
                                <div class="col-md-5">
                                    <label>Card Holder Name</label>
                                </div>
                                <div class="col-md-7 fourteenPixelText">
                                    <input class="form-control"
                                           name="cardHolderName"
                                           [(ngModel)]="creditCardInfo.cardHolderName">
                                </div>
                            </div>

                            <!-- ___ Postal Code ___ -->
                            <div class="row m-b-sm">
                                <div class="col-md-5">
                                    <label>Postal Code</label>
                                </div>
                                <div class="col-md-7 fourteenPixelText">
                                    <input class="form-control" name="postalCode" [(ngModel)]="creditCardInfo.postalCode">
                                </div>
                            </div>

                            <!-- ___ Credit Card Number ___ -->
                            <div class="row m-b-sm">
                                <div class="col-md-5">
                                    <label>Credit Card Number</label>
                                </div>
                                <div class="col-md-7 fourteenPixelText">
                                    <input class="form-control"
                                           name="creditCardNumber"
                                           [(ngModel)]="creditCardInfo.creditCardNumber">
                                </div>
                            </div>

                            <!-- ___ Expiry Date ___ -->
                            <div class="row m-b-sm">
                                <div class="col-md-5">
                                    <label>Expiry Date</label>
                                </div>
                                <div class="col-md-7 card-expiry-date-line">
                                    <select class="form-control" name="cardMonth" [(ngModel)]="creditCardInfo.cardMonth">
                                        <option value="" hidden></option>
                                        <option *ngFor="let month of cardMonthArray" [value]="month">{{month}}</option>
                                    </select>
                                    <select class="form-control" name="cardYear" [(ngModel)]="creditCardInfo.cardYear">
                                        <option value="" hidden></option>
                                        <option *ngFor="let year of cardYearsArray" [value]="year">{{year}}</option>
                                    </select>
                                </div>
                            </div>

                            <!-- ___ CVV ___ -->
                            <div class="row m-b-sm">
                                <div class="col-md-5">
                                    <label>CVV</label>
                                </div>
                                <div class="col-md-7 fourteenPixelText">
                                    <input class="form-control" name="cvv" [(ngModel)]="creditCardInfo.cvv">
                                </div>
                            </div>
                        </div>

                        <hr>

                        <div class="row m-b-sm sixteen-pixel-bold">
                            <div class="col-md-6">
                                <label>Total Payment Due</label>
                            </div>
                            <div class="col-md-3">
                                <label class="img-checkbox">
                                    <input id="fee"
                                           type="checkbox"
                                           name="fee"
                                           [disabled]="!data.paymentMethod"
                                           [(ngModel)]="data.payment.status">
                                    <label for="fee"><svg-checked></svg-checked></label>
                                    Paid
                                </label>
                            </div>
                            <div class="col-md-3 mtv-primary-color">
                                {{'$' + data.payment.amount}}
                            </div>
                        </div>

                        <div class="row text-center space-30">
                            <button class="btn btn-primary submit-btn" type="submit" [disabled]="disabledSubmit">
                                Save
                            </button>
                        </div>
                    </div>
                    <spinner [spinnerShow]="spinnerShow"></spinner>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/parking-pass/parking-pass-payment/parking-pass-payment.component.html